// Google Analytics 4 - Configuration avec Consent Mode v2
// REMPLACE 'G-XXXXXXXXXX' par ton vrai ID de mesure GA4

const GA_MEASUREMENT_ID = 'G-QFYSSM20X5';

// Typage pour gtag
declare global {
  interface Window {
    dataLayer: IArguments[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtag: (...args: any[]) => void;
  }
}

// Initialise le dataLayer et la fonction gtag
export function initGtag() {
  window.dataLayer = window.dataLayer || [];
  // IMPORTANT : utiliser `arguments` (pas les rest params) — Google's gtag.js
  // vérifie le type Arguments pour reconnaître les commandes consent/config/event.
  // Avec ...args (Array), les commandes consent sont ignorées (consent mode "inactive").
  // eslint-disable-next-line prefer-rest-params
  window.gtag = function gtag() { window.dataLayer.push(arguments as unknown as IArguments); };

  // Consent Mode v2 : par défaut tout est refusé (RGPD compliant)
  window.gtag('consent', 'default', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    wait_for_update: 500,
  });

  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, {
    send_page_view: false, // On gère les page_view manuellement (SPA)
  });
}

// Charge le script gtag.js de manière asynchrone
export function loadGtagScript() {
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  script.async = true;
  document.head.appendChild(script);
}

// Met à jour le consentement (appelé quand l'utilisateur accepte/refuse la bannière cookies)
// IMPORTANT : les 4 signaux du Consent Mode v2 doivent être mis à jour ensemble.
// N'en oublier qu'un seul (ex. ad_storage) le laisse bloqué sur son défaut "denied"
// à vie pour tout visiteur ayant déjà chargé la page — Google Ads ne peut alors
// jamais poser son cookie _gcl_aw ni suivre la conversion, même si l'utilisateur
// a explicitement accepté les cookies.
export function updateConsent(granted: boolean) {
  if (!window.gtag) return;

  const status = granted ? 'granted' : 'denied';
  window.gtag('consent', 'update', {
    analytics_storage: status,
    ad_storage: status,
    ad_user_data: status,
    ad_personalization: status,
  });
}

// Envoie un événement de page_view (pour le tracking SPA)
export function trackPageView(path: string, title?: string) {
  if (!window.gtag) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title || document.title,
  });
}

// Envoie un événement custom
export function trackEvent(eventName: string, params?: Record<string, unknown>) {
  if (!window.gtag) return;
  window.gtag('event', eventName, params);
}

export { GA_MEASUREMENT_ID };
